import React from "react";
import logo from "./logo.svg";
import Layout, { TAB_LOOKUP } from "./Layout";
import ArrowButton from "./ArrowButton";
import { useTranslation } from "react-i18next";

import { t } from "i18next";

import award1 from "./images/award1.png";
import award2 from "./images/award2.png";
import award3 from "./images/award3.png";
import award4 from "./images/award4.png";
import award5 from "./images/award5.png";
import award6 from "./images/award6.png";

import "./AwardsScreen.scss";

function AwardsScreen() {
  return (
    <div className="awards-screen-container fill-absolute">
      <div className="spacer" />
      <h2 className="blue-header" style={{ textAlign: "center" }}>
        {t("Award.title")}
      </h2>

      <div className="container awardsContainer">
        <div className="awardContainer">
          <div className="imageContainer">
            <img src={award1} alt="UC Awards 2021:Best Use of AI" />
          </div>
          <p className="textContainer">
            <div
              dangerouslySetInnerHTML={{
                __html: t("Award.award1_html", {
                  interpolation: { escapeValue: false },
                }),
              }}
            />
          </p>
        </div>
        <div className="awardContainer">
          <div className="imageContainer">
            <img src={award2} alt="Aragon Research Globe Leader 2021" />
          </div>
          <p className="textContainer">
            <div
              dangerouslySetInnerHTML={{
                __html: t("Award.award2_html", {
                  interpolation: { escapeValue: false },
                }),
              }}
            />
          </p>
        </div>
        <div className="awardContainer">
          <div className="imageContainer">
            <img src={award3} alt="	Metrigy Top Provider 2021" />
          </div>
          <p className="textContainer">
            <div
              dangerouslySetInnerHTML={{
                __html: t("Award.award3_html", {
                  interpolation: { escapeValue: false },
                }),
              }}
            />
          </p>
        </div>
        <div className="awardContainer">
          <div className="imageContainer">
            <img src={award4} alt="UC Awards 2021:Best CPaaS Platform" />
          </div>
          <p className="textContainer">
            <div
              dangerouslySetInnerHTML={{
                __html: t("Award.award4_html", {
                  interpolation: { escapeValue: false },
                }),
              }}
            />
          </p>
        </div>
        <div className="awardContainer">
          <div className="imageContainer">
            <img src={award5} alt="Ventana Research Value Index 2021" />
          </div>
          <p className="textContainer">
            <div
              dangerouslySetInnerHTML={{
                __html: t("Award.award5_html", {
                  interpolation: { escapeValue: false },
                }),
              }}
            />
          </p>
        </div>
        <div className="awardContainer">
          <div className="imageContainer">
            <img src={award6} alt="TMC 2021 Customer Product of the Year" />
          </div>
          <p className="textContainer">
            <div
              dangerouslySetInnerHTML={{
                __html: t("Award.award6_html", {
                  interpolation: { escapeValue: false },
                }),
              }}
            />
          </p>
        </div>
      </div>
      <div className="buttons-container">
        <ArrowButton to="/explore" side="left"></ArrowButton>
        <ArrowButton to="/conclusion" side="right"></ArrowButton>
      </div>
    </div>
  );
}

export default AwardsScreen;
